import { useState } from 'react';
import ImageInput from './components/ImageInput';

interface FlowStepInputProps {
    name: string;
    stepNumber: number;
    argumentType: string | string[] | undefined;
    value: string | number;
    onChange: (value: string | number) => void;
    onLaunchAssetPicker?: (callback: (value: string) => void) => void;
}
export default function FlowStepInput({
    name,
    stepNumber,
    argumentType = 'string',
    value,
    onChange,
    onLaunchAssetPicker,
}: FlowStepInputProps) {
    const [inputValue, setInputValue] = useState<string | number>(value);
    const isFileurl = argumentType === 'fileurl';
    const options = Array.isArray(argumentType) ? argumentType : undefined;

    const key = `${name}_${stepNumber}`;

    /*  useEffect(() => {
        if (value !== inputValue) {
            onChange(inputValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue]);*/

    return (
        <div className="flex flex-row" key={key}>
            <div className="flex-col flex align-center">
                <div className="capitalize">{name}:</div>
                {options ? (
                    <select
                        value={String(inputValue)}
                        onChange={(e) => {
                            setInputValue(e.target.value);
                            onChange(e.target.value);
                        }}
                        className="h-8 w-96 px-2 border border-gray-300 rounded-md"
                    >
                        {(options.includes(String(inputValue))
                            ? options
                            : [...options, String(inputValue)]
                        ).map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                ) : (
                    <input
                        type="text"
                        value={inputValue}
                        onBlur={() => {
                            onChange(inputValue);
                        }}
                        onChange={(e) => {
                            setInputValue(e.target.value);
                        }}
                        className="h-8 w-96 px-2 border border-gray-300 rounded-md"
                    />
                )}
            </div>
            {isFileurl && (
                <div className="mr-4">
                    <button
                        className="px-2 py-[4.5px] bg-gray-200 rounded-md mt-[21px] border-solid border-[1px] border-[lightgrey] cursor-pointer"
                        onClick={() => {
                            onLaunchAssetPicker &&
                                onLaunchAssetPicker((value) => {
                                    setInputValue(value);
                                    onChange(value);
                                });
                        }}
                    >
                        <i className="bi bi-folder2-open" />
                    </button>
                </div>
            )}

            {isFileurl && (
                <ImageInput
                    image={value as string}
                    onImageChange={(value) => {
                        if (value) {
                            setInputValue(value);
                            onChange(value);
                        }
                    }}
                    key={value}
                />
            )}
        </div>
    );
}
